import { GoogleEarthIcon } from './GoogleEarthIcon';

/**
 * author: Google
 * id 8A61F8F2-511B-45E9-9459-27BBD58936F8
 * name google-earth
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-earth.svg
 * tags
 * - Brand / Logo 
 */
export const MarbleIcon = GoogleEarthIcon;
export default MarbleIcon